// Modules
import { ErrorResponse } from 'apollo-link-error'
import { withFormik } from 'formik'
import * as H from 'history'
import React from 'react'

// Application
import { OutputErrorMsg } from 'constants/errorsService'
import { HelpModalInstances } from 'constants/helpmodal'
import { OutputErrorCode, ROUTES_PATH } from 'constants/index'
import { PersonalDataMDM } from 'typings'
import { PatientInfoInput, PersonalData, UserName } from 'typings/signup'
import { PersonalDataSchema } from './validation'

// Components
import { CheckAccountResponse, FormDataVerification } from 'typings/account'
import { FormValues, InnerForm } from '../InnerForm'
import { formattedBirthDateUSA } from 'utils'
export interface WrapperProps {
    personalData: PersonalData | undefined
    checkAccountService: (cpf: string, birthDate?: string) => Promise<CheckAccountResponse>
    setPersonalData: (data: PersonalData) => Promise<void>
    setPersonalDataMDM: (data: PersonalDataMDM) => Promise<void>
    verifyLoginRegistration: (cpf: UserName) => Promise<boolean>
    history: H.History
    setIsLoading: (loading: boolean) => void
    verifyPreUserRegistration: (patient: PatientInfoInput) => Promise<FormDataVerification>
    handleOpenModal: (helpModalInstance?: HelpModalInstances) => void
    trackEvent: (data: Partial<unknown>) => void
    toaster: (mes: string) => void
    anonymousPatient?: boolean
}

export const Wrapper: React.ComponentType<WrapperProps> = withFormik<WrapperProps, FormValues>({
    mapPropsToValues: ({ personalData }) => ({
        name: personalData?.name ?? '',
        socialName: personalData?.socialName ?? '',
        cpf: personalData?.cpf ?? '',
        birthDate: personalData?.birthDate ?? '',
        term: personalData?.term ?? false,
        genderIdentity: personalData?.genderIdentity ?? '',
        biologicalSex: personalData?.biologicalSex ?? '',
        hasSocialName: personalData?.socialName === undefined ? undefined : !!personalData?.socialName,
    }),
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    validationSchema: PersonalDataSchema,

    handleSubmit: (values, formikBag) => {
        const submitForm = async () => {
            const { props, setFieldError } = formikBag
            const { name, socialName, cpf, birthDate, term, genderIdentity, biologicalSex, hasSocialName } = values

            const checkMdmAccount = async () => {
                const { phoneContacts, emailContacts } = await props.verifyPreUserRegistration({
                    name,
                    socialName,
                    cpf,
                    birthDate,
                    term,
                })

                const personalData = {
                    name,
                    cpf,
                    socialName,
                    genderIdentity,
                    hasSocialName,
                    birthDate,
                    term,
                    biologicalSex,
                    phoneContacts,
                    emailContacts,
                }

                await props.setPersonalDataMDM(personalData)
                props.setIsLoading(false)

                props.history.push(ROUTES_PATH.SIGN_UP_MDM_CREATE_PASSWORD)
            }

            props.setIsLoading(true)
            await PersonalDataSchema.validate(values)

            try {
                const { status } = await props.checkAccountService(cpf, formattedBirthDateUSA(birthDate))

                if (status === OutputErrorCode.LOGINFOUND) {
                    setFieldError('cpf', 'CPF já cadastrado na plataforma')
                    props.setIsLoading(false)
                    return
                }
                if (
                    [OutputErrorCode.ACCOUNTNOTFOUND, OutputErrorCode.BACKOFFICE, OutputErrorCode.INSUFFICIENTDATA].includes(status!)
                ) {
                    const personalData = {
                        name,
                        socialName,
                        cpf,
                        birthDate,
                        genderIdentity,
                        biologicalSex,
                        hasSocialName,
                        term,
                        ...(props.anonymousPatient && { anonymousPatient: props.anonymousPatient }),
                    }

                    await props.setPersonalData(personalData)
                    props.setIsLoading(false)

                    props.history.push(ROUTES_PATH.SIGN_UP_CREATE_PASSWORD)
                    return
                }
                if (status === OutputErrorCode.NOT_ACCEPTABLE) {
                    props.setIsLoading(false)
                    props.history.push('/cadastrar/selecionar-contato/mdm')
                    return
                }
                await checkMdmAccount()
            } catch (err) {
                const e: ErrorResponse = err
                if (e.graphQLErrors) {
                    const codeError = e.graphQLErrors[0].extensions?.code
                    if (codeError === OutputErrorCode.UNDERAGE) {
                        /* eslint-disable max-len */
                        setFieldError(
                            'cpf',
                            'Este CPF é de um menor de idade. Para continuar, preencha com o CPF do responsável e adicione o menor de idade como dependente.',
                        )
                        props.setIsLoading(false)
                        return
                    }
                    if (codeError === OutputErrorCode.NOTACCEPTABLE) {
                        await checkMdmAccount()
                        return
                    }
                    if (codeError === OutputErrorCode.NOTEXISTS || codeError === OutputErrorCode.DECEASED) {
                        setFieldError('cpf', 'CPF inválido. Tente novamente ou tente acessar por Protocolo (CIP)')
                        props.setIsLoading(false)
                        return
                    }
                    if (codeError === OutputErrorCode.INVALIDBIRTHDATE) {
                        setFieldError('birthDate', 'Data de nascimento não corresponde ao CPF. Tente novamente')
                        props.setIsLoading(false)
                        return
                    }
                }
                props.setIsLoading(false)
                props.toaster(OutputErrorMsg.FORBIDDENERROR)
                props.setIsLoading(false)
                return
            }
        }
        submitForm()
    },
})(InnerForm)
